export const defaultLogState = {
	AccessLogData: [],
	Total: 0,
	CachedFilterOptions: {
		FromDate: null,
		ToDate: null
	}
};

export default {
	...defaultLogState
};
